import { __decorate, __metadata } from "tslib";
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { tooltipStyle } from './tooltip.style';
let TooltipElement = class TooltipElement extends LitElement {
    static { this.tagName = 'inch-tooltip'; }
    static { this.styles = tooltipStyle; }
    render() {
        return html `${this.text}`;
    }
};
__decorate([
    property({ type: String, attribute: true }),
    __metadata("design:type", String)
], TooltipElement.prototype, "text", void 0);
TooltipElement = __decorate([
    customElement(TooltipElement.tagName)
], TooltipElement);
export { TooltipElement };
//# sourceMappingURL=tooltip.element.js.map